import React, { useState } from 'react';
import { Box, Chip } from '@mui/material';
import { Link } from 'react-router-dom';

interface ExpandableChipListProps {
  chips: { key: string; label: string; to?: string }[];
  max?: number;
  chipSx?: object;
}

const ExpandableChipList: React.FC<ExpandableChipListProps> = ({
  chips,
  max,
  chipSx = {},
}) => {
  const [expanded, setExpanded] = useState(false);

  const shouldTruncate = max !== undefined && !expanded && chips.length > max;
  const displayChips = shouldTruncate ? chips.slice(0, max) : chips;
  const hiddenCount = chips.length - (max ?? 0);

  const defaultChipSx = {
    fontSize: { xs: '0.675rem', sm: '0.7rem' },
    height: { xs: '20px', sm: '24px' },
    bgcolor: 'rgba(255, 255, 255, 0.08)',
    color: 'text.primary',
    ...chipSx,
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {displayChips.map((chip) => (
        chip.to ? (
          <Chip
            key={chip.key}
            label={chip.label}
            component={Link}
            to={chip.to}
            clickable
            size="small"
            sx={defaultChipSx}
          />
        ) : (
          <Chip key={chip.key} label={chip.label} size="small" sx={defaultChipSx} />
        )
      ))}
      {shouldTruncate && (
        <Chip
          label={`+${hiddenCount}`}
          size="small"
          onClick={() => setExpanded(true)}
          sx={{
            ...defaultChipSx,
            cursor: 'pointer',
            bgcolor: 'rgba(255, 255, 255, 0.15)',
            '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.22)' },
          }}
        />
      )}
    </Box>
  );
};

export default ExpandableChipList;
